<template>
    <modal id="course-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('course')"
           @submit="submit"
           :loading="loading"
           :preloader="preloader"

    >
        <form :data-url='selectedUrl ? selectedUrl : apiUrl.COURSE'
              method="POST"
              ref="form"
              enctype="multipart/form-data"
              @submit.prevent="submitData">
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('title')"
                        type="text"
                        v-model="formData.title"
                        :placeholder="$placeholder('title')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'title')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('description')"
                        type="text"
                        v-model="formData.description"
                        :placeholder="$placeholder('description')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'description')"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('courses.passing_score')"
                        type="number"
                        v-model="formData.passing_score"
                        :placeholder="$placeholder('courses.passing_score')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'passing_score')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="multi-select"
                        :label="$t('departments')"
                        list-value-field="name"
                        v-model="formData.departments"
                        :chooseLabel="$t('departments')"
                        :error-message="$errorMessage(errors, 'departments')"
                        :fetch-url="SELECTABLE_DEPARTMENT"
                    />
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {
    errorMessageInArray,
    formDataAssigner
} from "../../../../../common/Helper/Support/FormHelper";
import {axiosPost} from "../../../../../common/Helper/AxiosHelper";
import {SELECTABLE_DEPARTMENT} from "../../../../Config/ApiUrl";


export default {
    name: "CourseCreateEdit",
    components: {},
    mixins: [FormHelperMixins, ModalMixin],
    comments: {},
    data() {
        return {
            errorMessageInArray,
            formData: {
                title: '',
                description: '',
                passing_score: '',
                departments: []
            },
            SELECTABLE_DEPARTMENT
        };
    },
    computed: {
    },
    methods: {
        submit() {
            this.loading = true;
            let formData = {...this.formData}
            formData = formDataAssigner(new FormData, formData);
            this.formData.departments.forEach((id, index) => {
                formData.append(`departments[${index}]`, id);
            });
            let url = this.apiUrl.COURSE;
            if (this.selectedUrl) {
                formData.append('_method', "PUT");
                url = this.selectedUrl;
            }
            axiosPost(url, formData).then(({data}) => {
                this.loading = false;
                $('#course-modal').modal('hide');
                $('.modal-backdrop').remove();
                this.showModal = false;
                this.toastAndReload(data.message, 'course-table');
                window.location.reload();
            }).catch(({response}) => {
                this.loading = false;
                this.message = '';
                this.errors = response.data.errors || {};
                this.fieldStatus.isSubmit = true;
                if (response.status !== 422) {
                    this.$toastr.e(response.data.message || response.statusText);
                }
            });

        },
        afterSuccess({data}) {
            this.formData = {};
            $('#course-modal').modal('hide');
            this.toastAndReload(data.message, 'course-table')
            this.$emit('input', false);
        },
        afterError(response) {
            this.loading = false;
            this.errors = response.data.errors;
        },
        afterSuccessFromGetEditData({data}) {
            this.preloader = false;
            this.formData = data;
            this.formData.departments = this.collection(data.departments).pluck();
        },
    }
}
</script>
